import { createReducer, Action, on, createFeatureSelector, createSelector } from '@ngrx/store';
import { PushNotificationSchema } from '@capacitor/push-notifications';
import { AddPushNotification, RemovePushNotification, ClearPushNotifications, ResetPushNotification } from './push-notification.actions';

export const name = 'push-notification';

export interface PushNotificationState {
  items: PushNotificationSchema[];
}

export const initialState: PushNotificationState = {
  items: []
};

const pushNotificationReducer = createReducer<PushNotificationState, Action>(
  initialState,
  on(ResetPushNotification, () => initialState),
  on(AddPushNotification, (state: PushNotificationState, action: { pushNotification: PushNotificationSchema }) => {
    if(state.items.findIndex((notification) => (notification.id === action.pushNotification.id)) !== -1) {
      return state;
    }
    return {
      ...state,
      items: [action.pushNotification, ...state.items]
    };
  }),
  on(RemovePushNotification, (state: PushNotificationState, payload: { id: string }) => {
    const filteredPushNotifications = state.items.filter((item: PushNotificationSchema) => {
      if (item.id === payload.id) {
        return false;
      }
      return true;
    });
    return {
      ...state,
      items: filteredPushNotifications
    };
  }),
  on(ClearPushNotifications, (state: PushNotificationState) => ({ ...state, items: [] }))
);

export const reducer = (state: PushNotificationState | undefined, action: Action) => pushNotificationReducer(state, action);

export const selectPushNotification = createFeatureSelector<PushNotificationState>(name);
export const getPushNotificationItems = createSelector(selectPushNotification, (state: PushNotificationState) => state.items);
